<template>
  <Dialog
    v-model:visible="localVisible"
    modal
    :header="headerMsg"
    :style="{ width: '28rem' }"
    :closable="false"
  >
    <div class="flex items-center gap-4">
      <span
        v-if="message"
        v-html="message"
      />
    </div>
    <template #footer>
      <Button
        label="I Understand"
        severity="primary"
        icon="pi pi-check"
        @click="confirmAction"
      />
    </template>
  </Dialog>
</template>

<script>
  import { defineComponent, ref, watch } from "vue";

  export default defineComponent({
    name: "EnvironmentInfoDialog",
    props: {
      headerMsg: {
        type: String,
        required: true
      },
      visible: {
        type: Boolean,
        required: true
      },
      message: {
        type: String,
        required: true
      },
      onConfirm: {
        type: Function,
        required: true
      }
    },
    emits: ["update:visible", "confirm"],
    setup(props, { emit }) {
      const localVisible = ref(props.visible);

      watch(
        () => props.visible,
        (newVal) => {
          localVisible.value = newVal;
        }
      );

      watch(
        () => localVisible.value,
        (newVal) => {
          emit("update:visible", newVal);
        }
      );

      const closeDialog = () => {
        localVisible.value = false;
      };

      const confirmAction = () => {
        props.onConfirm();
        closeDialog();
      };

      return {
        localVisible,
        closeDialog,
        confirmAction
      };
    }
  });
</script>
